var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{attrs:{"effect":"dark","content":"大屏显示","placement":"bottom"}},[_c('el-button',{staticClass:"d2-ml-0 d2-mr btn-text can-hover",attrs:{"type":"text"},on:{"click":_vm.gotoBigScreen}},[_c('d2-icon',{staticStyle:{"font-size":"16px"},attrs:{"name":"television"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }